
import React, { useContext, useEffect, useRef, useState } from "react";
import ConfirmBox from "./ConfirmBox";
import toast from "react-hot-toast";
import AuthContext from "../context/AuthContext";
import useAuthFetch from "../hooks/useAuthFetch";

const ToggleSwitch = () => {
    const checkedRef = useRef()
    const [openConfirmBox, setOpenConfirmBox] = useState(false)
    const [deactivationReason, setDeactivationReason] = useState(null)
    const [checkValue, setCheckValue] = useState(false)
    const { user } = useContext(AuthContext);
    const customFetch = useAuthFetch()



    useEffect(() => {
        checkMaintenanceStatus()
    }, [])

    const handleToggle = (e) => {
        const checked = e.target.checked;
        checkedRef.current = checked
        setOpenConfirmBox(true)
    };

    const checkMaintenanceStatus = async () => {
        try {
            const url = new URL(`${process.env.REACT_APP_API_URL}/v1/dashboard/checkMaintenanceStatus`);
            const method = "GET"
            const { response, status } = await customFetch(
                url,
                method,
            );
            if (status === 200) {
                setCheckValue(response.underMaintenance)
            }
        } catch (e) {

        }
    }

    const changeMaintenanceStatus = async (value) => {
        try {
            const url = new URL(`${process.env.REACT_APP_API_URL}/v1/dashboard/changeMaintenanceStatus`);

            const method = "POST"

            let bodyContent;
            if (value) {
                bodyContent = {
                    isUnderMaintenance: true,
                    maintenanceActivatedBy: user?.userName,
                    ntID: user?.ntID
                }
            } else {
                bodyContent = {
                    isUnderMaintenance: false,
                    maintenanceDeactivatedBy: user?.userName,
                    ntID: user?.ntID,
                    maintenanceDeactivationReason: deactivationReason ? deactivationReason : null
                }
            }


            const { response, status, message } = await customFetch(
                url,
                method,
                bodyContent
            );
            if (status === 200) {
                toast.success(message, {
                    position: "bottom-right",
                });
            } else {
                toast.error(message ? message : "Something went wrong", {
                    position: "bottom-right"
                })
            }
            checkMaintenanceStatus()
            setDeactivationReason(null)
        } catch (e) {
            toast.error(`Something went wrong : ${e}`, {
                position: "bottom-right"
            })
        }
    }

    return (
        <>
            <label className="flex items-center cursor-pointer mr-3">
                <span className={`ms-3 mr-3 font-bold ${checkValue ? "text-red-600 " : "text-green-600"} `}>
                    {checkValue ? "SYSTEM UNDER MAINTENANCE" : "SYSTEM OPERATIONAL"}
                </span>
                <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={checkValue}
                    onChange={handleToggle}
                />
                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>

            </label>
            {openConfirmBox && <ConfirmBox
                open={openConfirmBox}
                setOpen={setOpenConfirmBox}
                buttonText={"Confirm"}
                buttonHandler={async () => {
                    const value = checkedRef.current
                    await changeMaintenanceStatus(value)
                    setOpenConfirmBox(false)

                }}
                checkValue={checkedRef.current}
                setDeactivationReason={setDeactivationReason}
                deactivationReason={deactivationReason}
                extraButtonText={"Cancel"}
                extraButtonHandler={() => {
                    setOpenConfirmBox(false)
                }}

                text={checkedRef.current ? "Are you sure you want to update the maintenance status and mark the system as under maintenance?" : "Are you sure you want to update the maintenance status and mark the system as operational?"} />}
        </>
    );
};

export default ToggleSwitch;
